import React from 'react';
import Icon from '../../../components/AppIcon';
import departmentalBudgetService from '../../../services/departmentalBudgetService';

const DepartmentBudgetTable = ({ budgets, onSelectBudget }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'text-success bg-success/10';
      case 'approved':
        return 'text-primary bg-primary/10';
      case 'draft':
        return 'text-warning bg-warning/10';
      case 'closed':
        return 'text-muted-foreground bg-muted';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const getVarianceColor = (variance) => {
    if (variance > 10) return 'text-error';
    if (variance > 0) return 'text-warning';
    if (variance < -10) return 'text-success';
    return 'text-muted-foreground';
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-medium text-foreground">Department</th>
              <th className="px-4 py-3 text-left text-sm font-medium text-foreground">Fiscal Period</th>
              <th className="px-4 py-3 text-right text-sm font-medium text-foreground">Allocated Budget</th>
              <th className="px-4 py-3 text-right text-sm font-medium text-foreground">Spent</th>
              <th className="px-4 py-3 text-right text-sm font-medium text-foreground">Remaining</th>
              <th className="px-4 py-3 text-right text-sm font-medium text-foreground">Variance</th>
              <th className="px-4 py-3 text-center text-sm font-medium text-foreground">Status</th>
              <th className="px-4 py-3 text-center text-sm font-medium text-foreground">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {budgets?.map((budget) => (
              <tr key={budget?.id} className="hover:bg-muted/50 transition-smooth">
                <td className="px-4 py-3">
                  <div className="flex items-center gap-2">
                    <Icon name="Building2" size={18} color="var(--color-primary)" />
                    <span className="font-medium text-foreground">{budget?.department}</span>
                  </div>
                </td>
                <td className="px-4 py-3 text-sm text-muted-foreground">
                  {budget?.fiscalPeriod}
                </td>
                <td className="px-4 py-3 text-right font-medium text-foreground">
                  {departmentalBudgetService?.formatKina(budget?.allocatedBudgetKina)}
                </td>
                <td className="px-4 py-3 text-right text-foreground">
                  {departmentalBudgetService?.formatKina(budget?.spentAmountKina)}
                </td>
                <td className="px-4 py-3 text-right text-foreground">
                  {departmentalBudgetService?.formatKina(budget?.remainingBalanceKina)}
                </td>
                <td className={`px-4 py-3 text-right font-medium ${getVarianceColor(budget?.variancePercentage)}`}>
                  {budget?.variancePercentage > 0 ? '+' : ''}{departmentalBudgetService?.formatPercentage(budget?.variancePercentage)}
                </td>
                <td className="px-4 py-3 text-center">
                  <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(budget?.budgetStatus)}`}>
                    {budget?.budgetStatus}
                  </span>
                </td>
                <td className="px-4 py-3 text-center">
                  <button
                    onClick={() => onSelectBudget?.(budget)}
                    className="inline-flex items-center gap-1 px-3 py-1 text-sm text-primary hover:bg-primary/10 rounded-md transition-smooth"
                  >
                    <Icon name="Eye" size={16} color="currentColor" />
                    View Details
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DepartmentBudgetTable;